import {Booking} from "./booking.service";
import moment from 'moment-timezone'

const TimezoneService = {
    /**
     * Correct timezone for creating a booking from a different timezone
     */
    correctTimezoneDifferenceUp(booking) {
        let startDate = moment(booking.entity.startDate) // get the start date
        let endDate = moment(booking.entity.endDate) // get the end date
        let location = booking.location // get the location

        /**
         * correct the dates based on the location timezone off set according to the following example:
         * Site = UTC + 2
         * Booker = UTC + 1
         * DB = UTC
         * timezone offset = 2h --> 120min
         * Correction --> 120 - 60min
         * Subtract the correction from the dates
         */
        let locationOffset = moment(startDate).tz(location.timezoneName).utcOffset() // get the utc offset for the location
        startDate = startDate.subtract(locationOffset - startDate.utcOffset(), "m")
        endDate = endDate.subtract(locationOffset - endDate.utcOffset(), "m")

        // update the booking
        let b = booking
        b.entity.startDate = startDate.toDate().toISOString()
        console.log("startDate corrected", b.entity.startDate)
        b.entity.endDate = endDate.toDate().toISOString()

        return b
    },

    /**
     * Correct timezone for booking included in the entities get call
     */
    correctTimezoneDifferenceDownEntities(booking, location) {
        let startDate = moment(booking.startDate) // get the start date
        let endDate = moment(booking.endDate) // get the end date

        /**
         * correct the dates based on the location timezone off set according to the following example:
         * Site = UTC + 2
         * Booker = UTC + 1
         * DB = UTC
         * timezone offset = 2h --> 120min
         * Correction --> 120 - 60min
         * add the correction to the dates
         */
        const locationOffset = moment(startDate).tz(location.timezoneName).utcOffset()
        const dateOffset = startDate.utcOffset()
        const offset = locationOffset - dateOffset

        startDate.add(offset, "m")
        endDate.add(offset, "m")

        // update the booking
        let b = booking
        b.startDate = startDate.toDate()
        b.endDate = endDate.toDate()

        return b
    },

    /**
     * correct all bookings
     * @param bookings
     * @param location
     */
    correctAllBookingsDown (bookings, location) {
        let correctedBookings = []
        for (let i = 0; i < bookings.length; i++) {
            correctedBookings.push(this.correctTimezoneDifferenceDown(bookings[i], location))
        }

        return correctedBookings
    },

    /**
     * Correct timezone for getting a booking from a different timezone
     */
    correctTimezoneDifferenceDown(booking, location) {
        let startDate = moment(booking.entity.startDate) // get the start date
        let endDate = moment(booking.entity.endDate) // get the end date
        /**
         * correct the dates based on the location timezone off set according to the following example:
         * Site = UTC + 2
         * Booker = UTC + 1
         * DB = UTC
         * timezone offset = 2h --> 120min
         * Correction --> 120 - 60min
         * Add correction to the dates
         */

        // l = + 60
        // u = + 120
        const locationOffset = moment(startDate).tz(location.timezoneName).utcOffset()
        const dateOffset = startDate.utcOffset()

        const offset = locationOffset - dateOffset

        startDate.add(offset, "m")
        endDate.add(offset, "m")
        // update the booking
        let b = booking
        b.entity.startDate = startDate.toDate()
        b.entity.endDate = endDate.toDate()

        return b
    },
    /**
     * Local helper function to correct arrivals
     */
    correctArrivalsArray(arr, location) {
        let result = arr

        for (let i = 0; i < arr.length; i ++) {
            let startDate = moment(arr[i].startDate)
            let endDate = moment(arr[i].endDate)
            // correct
            const locationOffset = moment(startDate).tz(location.timezoneName).utcOffset()
            const dateOffset = startDate.utcOffset()

            const offset = locationOffset - dateOffset

            startDate.add(offset, "m")
            endDate.add(offset, "m")
            result[i].startDate = startDate.toDate().toISOString()
            result[i].endDate = endDate.toDate().toISOString()
        }

        return result
    },

    /**
     * Correct timezone for arrivals
     */
    correctTimezoneDifferenceArrivals(arrivals, location) {
        let result = arrivals

        result.expected = result.expected !==  undefined ? this.correctArrivalsArray(arrivals.expected, location) : result.expected
        result.arrived = result.arrived !== undefined ? this.correctArrivalsArray(arrivals.arrived, location) : result.arrived
        result.delayed = result.delayed !== undefined ? this.correctArrivalsArray(arrivals.delayed, location) : result.delayed

        return result
    }
}

export {TimezoneService}
